const Reports = () => {
    return ( 
        <div>
            <h2>Reports</h2>
            <p>Welcome to the Reports!</p>
        </div>
     );
}
 
export default Reports;